/* global fbq */

import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faUndoAlt,
  faBolt,
  faThumbsUp,
  faPuzzlePiece,
  faCreditCard,
  faChartLine,
  faArrowRight,
  faArrowDown,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import splashart from '../assets/splashart.jpg';import {
  Container,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
  Button
} from '@mui/material';
import axios from 'axios';
import Popup from 'reactjs-popup';
import NewPassword from './NavBar/SignIn/NewPassword.js';
import { useAuth } from '../contexts/AuthContext.js';

import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


import { Helmet } from 'react-helmet-async';

import OG from '../assets/og/home.png';
import logo from '../assets/Logos/Logo.png';
import ReviewsCarousel from '../components/ReviewsCarousel.js';
import LatestPostsCarousel from '../components/LatestPostsCarousel.js';

const Home = () => {

  const navigate = useNavigate();
  const { getAccessToken } = useAuth();
  
  const { random_id } = useParams();

  const [isMobile, setIsMobile] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);

  const MySwal = withReactContent(Swal);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 640);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const pushToDataLayer = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  // Mobile: only top gradient + image
  const mobileBg = [
    'linear-gradient(to top, #000 0%, rgba(0,0,0,0) 25%)',
    `url(${splashart})`
  ];

  // Desktop: left, right, top gradients + image
  const desktopBg = [
    'linear-gradient(to right, #000 0%, rgba(0,0,0,0) 25%)',
    'linear-gradient(to left, #000 0%, rgba(0,0,0,0) 25%)',
    'linear-gradient(to top, #000 0%, rgba(0,0,0,0) 25%)',
    `url(${splashart})`
  ];

  const gradients = isMobile ? mobileBg : desktopBg;
  const positions = gradients.map((_, i) =>
    i === gradients.length - 1 ? 'center top' : 'center'
  );

  // Styled dark accordion
const DarkAccordion = styled(Accordion)(() => ({
  backgroundColor: 'var(--bg-surface-variant)',
  color: 'white',
  border: '1px solid var(--border)',
  borderRadius: '0.5rem',
  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  '&:not(:last-of-type)': {
    marginBottom: '1rem'
  },
  '&:before': {
    display: 'none'
  }
}));

const faqItems = [
  {
    question: 'Is boosting safe and allowed?',
    answer: `Our methods are designed for safety – we use VPNs and appear offline so friends won’t notice. However, account sharing is against Riot’s ToS. Use at your own discretion. We also offer duo boosting which does not violate ToS.`
  },
  {
    question: 'What if I need a refund?',
    answer: `If your order hasn’t started, you get a full refund. For partially completed orders, we issue pro-rated refunds depending on progress. Support is available 24/7 via discord.`
  },
  {
    question: 'How long does boosting take?',
    answer: `Most orders start within less than an hour of purchase. Completion time varies by service and order type: division boosts average 2–5 hours; net-win orders depend on target; placement games usually finish within 2-3 hours.`
  },
  {
    question: 'Will I get banned?',
    answer: `We take precautions (VPNs, offline mode) to minimize risk, but no third-party service can guarantee zero risk. Use responsibly.`
  },
  {
    question: 'What payment methods do you accept?',
    answer: `We use Stripe as our payment system, you can use Visa, American Express, Mastercard. All transactions are SSL-secured.`
  },
  {
    question: 'How can I track my order?',
    answer: `After purchase, you can check your current order progress in your orders panel. You can chat with your booster through that interface.`
  },
  {
    question: 'Can I cancel my order?',
    answer: `You can cancel before the booster starts. After start, refunds are pro-rated based on remaining games or divisions.`
  },
  {
    question: 'Do you offer coaching sessions?',
    answer: `Yes—click “Get Coaching” at the top to book a 1-on-1 session tailored to your needs.`
  }
];

  useEffect(() => {
      if(window.location.href.includes('reset-password')) {
          setResetPassword(true);
      } 
      if(random_id) {
          axios.post(`${process.env.REACT_APP_API_URL}/user/verify-discord/${random_id}`, {}, {
              headers: { 
                  Authorization: getAccessToken() 
              },
          }).then(response => {
              MySwal.fire({
                  title: 'Discord Verification',
                  text: 'Your Discord account has been successfully verified!',
                  icon: 'success',
                  confirmButtonText: 'Ok'
              }).then(() => {
                  navigate('/');
              });
          }).catch(error => {
              console.error(error);
              MySwal.fire({
                  title: 'Discord Verification',
                  text: 'An error occurred while verifying your Discord account. Please try again later.',
                  icon: 'error',
                  confirmButtonText: 'Ok'
              }).then(() => {
                  navigate('/');
              });
          });
      } else {
          if(!resetPassword) {
              /*
              MySwal.fire({
                  title: '18% OFF for a limited time!',
                  text: 'Use code: SPRING18 for 18% off your order! 🎁',
                  icon: 'success',
                  confirmButtonText: 'Ok'
              });
              */
          }
      }
  }, []);


  const handleBoosting = () => {
    if (typeof fbq !== 'undefined') {
        fbq('track', 'ViewContent', {
          service: 'Boosting',
          source: 'Home',
        });
    }
    pushToDataLayer({
      event:   'view_content',   // your GTM Custom Event trigger name
      service: 'Boosting',
      source:  'Home',
    });
    navigate('/get-boosting/division-boosting');
  }

  const handleCoaching = () => {
    if (typeof fbq !== 'undefined') {
        fbq('track', 'ViewContent', {
          service: 'Coaching',
          source: 'Home',
        });
    }
    pushToDataLayer({
      event:   'view_content',   // same trigger, just different params
      service: 'Coaching',
      source:  'Home',
    });
    navigate('/get-coaching/mixed');
  }

  return (
    <div className="flex flex-col min-h-screen font-sans text-white bg-black gap-16">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Fast, Affordable LoL Boosting &amp; Coaching | EloFactory.gg</title>
        <meta name="description" content="Premium League of Legends boosting and coaching by EloFactory's pro players. Safe, fast, and affordable rank improvement. 24/7 support – start climbing now!" />
        <link rel="canonical" href="https://elofactory.gg/" />
        <meta property="og:type" content="website" />
        <meta property="og:title"
        content="Fast LoL Boosting &amp; Coaching Services | EloFactory.gg" />
        <meta property="og:description" content="Level up your LoL rank with professional elo boosting and personalized coaching. Trusted boosters, quick results, and secure service. Climb the ladder today!" />
        <meta property="og:url" content="https://elofactory.gg/" />
        <meta property="og:image" content={OG} />
        <meta property="og:image:width"  content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="EloFactory.gg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fast LoL Boosting &amp; Coaching Services | EloFactory.gg" />
        <meta name="twitter:description" content="Reach your dream rank with our League of Legends boosting and coaching. Affordable prices, top boosters, and 24/7 support. Get started now!" />
        <meta name="twitter:image" content={OG} />
        <meta name="twitter:site" content="@elofactorygg" />
        <meta name="twitter:creator" content="@elofactorygg" />
        <meta name="robots" content="index, follow" />
        <link rel="alternate" hrefLang="en-US" href="https://elofactory.gg/" />
        <script type="application/ld+json">{`
        {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "EloFactory",
        "url": "https://elofactory.gg/",
        "logo": "${logo}",
        "sameAs": [
        "https://twitter.com/elofactorygg",
        "https://www.instagram.com/elofactory.gg"
        ],
        "description": "League of Legends boosting and coaching services to help players rank up quickly and safely."
        }
        `}</script>
      </Helmet>

      <Popup open={resetPassword} closeOnEscape closeOnDocumentClick modal nested>
          <NewPassword key={'reset-password'} closeModal={() => navigate('/')}/>
      </Popup>
      {/* Hero Section */}
      <header className="relative overflow-hidden bg-[var(--bg-page)] mb-32 h-[75vh] sm:h-auto"
      style={{
        backgroundImage: gradients.join(','),
        backgroundSize: gradients.map(() => 'cover').join(','),
        backgroundPosition: positions.join(','),
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 bg-[var(--bg-page)] opacity-[0.25] sm:opacity-40 mix-blend-multiply"></div>

      <div
        className="
          relative max-w-7xl mx-auto px-6 sm:px-0 lg:px-12 
          flex flex-col justify-end       /* bottom-align on mobile */
          sm:flex-col-reverse lg:flex-row lg:justify-start  /* large: row, left-aligned */
          md:flex-row md:justify-start md:px-8
          items-center gap-10 h-full
          py-28 sm:py-22 md:py-28 lg:py-32          /* tighter on xs */
        "
      >
        {/* Hero Text */}
        <div className="lg:w-[550px] md:w-[450px] sm:w-[400px] z-10 p-6 rounded-md lg:ml-0 text-left sm:text-left bg-gray-800/60 shadow-lg">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold sm:mb-2 md:mb-4 leading-tight">
            <span>LEAGUE OF LEGENDS </span>
            <br/>
            <span className="text-[var(--blue)]">BOOSTING</span>
          </h1>
          {/* Mobile-only paragraph */}
          <p className="block sm:hidden text-base text-[var(--secondary-text)] mb-6">
            Your trusted partner for fast, safe, and reliable League of Legends <strong className="text-white">boosting</strong> and <strong className="text-white">coaching</strong> services.
          </p>
          {/* hide on xs to reduce clutter */}
          <p className="hidden sm:block text-base sm:text-sm md:text-lg lg:text-lg text-[var(--secondary-text)] mb-8">
            Premium, safe, and fast League of Legends <strong className="text-white">boosting</strong> and <strong className="text-white">coaching</strong> services. Reach your desired rank or skill level effortlessly with help from Challenger experts.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              onClick={handleBoosting}
              className="cursor-pointer bg-[var(--blue)] text-white text-center font-semibold py-4 px-8 rounded-full shadow-lg hover:text-[var(--blue)] hover:bg-white border border-[var(--focus-ring)] hover:border-[var(--blue)] transition focus:outline-none focus:ring-1 focus:ring-[var(--focus-ring)]"
              aria-label="Get Boosting – start a boost order"
            >
              Get Boosting
            </a>
            <a
              onClick={handleCoaching}
              className="cursor-pointer border border-[var(--blue)] bg-transparent text-white text-center font-semibold py-4 px-8 rounded-full hover:bg-[var(--blue)] transition focus:outline-none focus:ring-1 focus:ring-[var(--focus-ring)]"
              aria-label="Get Coaching – book a coaching session"
            >
              Get Coaching
            </a>
          </div>
        
        </div>
      </div>
      <div className="absolute inset-x-0 bottom-0 h-[1px] bg-black z-30 pointer-events-none" />

      </header>


      {/* Reviews.io ReviewsCarousel */}
      <section className="flex max-w-6xl mx-auto px-6 py-8 md:py-0 md:pt-4 bg-[var(--bg-page)] rounded-lg w-full border border-[var(--bg-surface)] shadow-lg justify-center items-center">
        <ReviewsCarousel />
      </section>

      {/* Trust / Benefits Section */}
      <section
        className="max-w-6xl mx-auto px-6 py-14 grid grid-cols-1 
        sm:grid-cols-2 lg:grid-cols-4 text-center bg-[var(--bg-page)] rounded-lg
        border border-[var(--bg-surface)] shadow-lg"
      >
        <div className='col-span-full mb-8'>
          <h2 className="text-2xl font-bold text-center mb-2 text-[var(--blue)] col-span-full">
            Why Choose EloFactory?
          </h2>
          <p className="text-center text-sm text-secondary max-w-2xl mx-auto mb-8 col-span-full">
            We are committed to providing the best boosting and coaching experience. Here’s why you can trust us:
          </p>
        </div>
        <div className="flex flex-col items-center mb-6">
          <FontAwesomeIcon icon={faShieldAlt} className="text-5xl text-[var(--blue)] mb-4" />
          <h3 className="font-semibold text-lg mb-2">VPN Protected</h3>
          <p className="text-sm text-[var(--secondary-text)]">
            All boosts use <strong>VPN encryption</strong> and appear offline for maximum security.
          </p>
        </div>
        <div className="flex flex-col items-center mb-6">
          <FontAwesomeIcon icon={faUndoAlt} className="text-5xl text-[var(--blue)] mb-4" />
          <h3 className="font-semibold text-lg mb-2">Money-Back Guarantee</h3>
          <p className="text-sm text-[var(--secondary-text)]">
            100% <strong>refund policy</strong> – get full or partial refund if your order isn’t completed.
          </p>
        </div>
        <div className="flex flex-col items-center mb-6">
          <FontAwesomeIcon icon={faBolt} className="text-5xl text-[var(--blue)] mb-4" />
          <h3 className="font-semibold text-lg mb-2">Fast & Reliable</h3>
          <p className="text-sm text-[var(--secondary-text)]">
            <strong>24/7 service</strong> with instant order start. Average start time in under an hour.
          </p>
        </div>
        <div className="flex flex-col items-center">
          <FontAwesomeIcon icon={faThumbsUp} className="text-5xl text-[var(--blue)] mb-4" />
          <h3 className="font-semibold text-lg mb-2">Trusted by Players</h3>
          <p className="text-sm text-[var(--secondary-text)]">
            Powered by <strong>top-tier</strong> pros—every boost comes with our satisfaction guarantee.
          </p>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="max-w-6xl mx-auto px-6 py-14 bg-[var(--bg-page)] rounded-lg w-full border border-[var(--bg-surface)] shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-2 text-[var(--blue)]">How It Works</h2>
        <p className="text-center text-sm text-secondary max-w-2xl mx-auto mb-8">
          Getting started is easy! Follow these simple steps to boost your rank or skill level:
        </p>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
          {/* Step 1 */}
          <div className="flex flex-col items-center text-center">
            <FontAwesomeIcon
              icon={faPuzzlePiece}
              className="text-4xl text-[var(--blue)] mb-4"
            />
            <h4 className="font-semibold text-lg mb-2">Select Service</h4>
            <p className="text-sm text-[var(--secondary-text)] max-w-xs text-left">
              Choose your mode (division, net wins, placement, etc.) and preferences like role or champion.
            </p>
          </div>

          {/* Arrow → on lg+, ↓ on mobile */}
          <FontAwesomeIcon
            icon={faArrowRight}
            className="text-[var(--blue)] text-3xl hidden lg:block"
          />
          <FontAwesomeIcon
            icon={faArrowDown}
            className="text-[var(--blue)] text-3xl block lg:hidden"
          />

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center">
            <FontAwesomeIcon
              icon={faCreditCard}
              className="text-4xl text-[var(--blue)] mb-4"
            />
            <h4 className="font-semibold text-lg mb-2">Checkout Securely</h4>
            <p className="text-sm text-[var(--secondary-text)] max-w-xs text-left">
              Register anonymously and pay via SSL-secured checkout. All major payment methods accepted.
            </p>
          </div>

          {/* Arrow → on lg+, ↓ on mobile */}
          <FontAwesomeIcon
            icon={faArrowRight}
            className="text-[var(--blue)] text-3xl hidden lg:block"
          />
          <FontAwesomeIcon
            icon={faArrowDown}
            className="text-[var(--blue)] text-3xl block lg:hidden"
          />

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center">
            <FontAwesomeIcon
              icon={faChartLine}
              className="text-4xl text-[var(--blue)] mb-4"
            />
            <h4 className="font-semibold text-lg mb-2">Rank Up</h4>
            <p className="text-sm text-[var(--secondary-text)] max-w-xs text-left">
              Track progress live and chat with your booster or coach. Enjoy your improved rank!
            </p>
          </div>
        </div>
      </section>


      {/* Featured Boosters/Coaches */}
      <section className="max-w-6xl mx-auto px-6 py-14 bg-[var(--bg-page)] rounded-lg w-full border border-[var(--bg-surface)] shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-2 text-[var(--blue)]">Meet Our Top Boosters & Coaches</h2>
        <p className="text-center text-sm text-secondary max-w-2xl mx-auto mb-8">
          Only <strong>Top-tier</strong> experts with proven track records make it into our roster. Our team is friendly, professional, and dedicated to helping you succeed.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-[var(--bg-surface)] border border-[var(--border)] p-4 rounded shadow-md flex flex-col items-center">
            <img width={80} height={80} alt="Booster profile" className="mb-3 rounded-full" src={require('../assets/boosters/shuki.png')}/>
            <h4 className="font-semibold">Shuki</h4>
            <p className="text-xs text-secondary">Master NA • Top Laner</p>
          </div>
          <div className="bg-[var(--bg-surface)] border border-[var(--border)] p-4 rounded shadow-md flex flex-col items-center">
            <img width={80} height={80} alt="Booster profile" className="mb-3 rounded-full" src={require('../assets/boosters/phantom.png')}/>
            <h4 className="font-semibold">Phantom</h4>
            <p className="text-xs text-secondary">Grandmaster NA • 300+ orders</p>
          </div>
          <div className="bg-[var(--bg-surface)] border border-[var(--border)] p-4 rounded shadow-md flex flex-col items-center">
            <img width={80} height={80} alt="Booster profile" className="mb-3 rounded-full" src={require('../assets/boosters/maverick.png')}/>
            <h4 className="font-semibold">Maverick</h4>
            <p className="text-xs text-secondary">Grandmaster Coach • EUW</p>
          </div>
          <div className="bg-[var(--bg-surface)] border border-[var(--border)] p-4 rounded shadow-md flex flex-col items-center">
            <img width={80} height={80} alt="Booster profile" className="mb-3 rounded-full" src={require('../assets/boosters/stitch.png')}/>
            <h4 className="font-semibold">St1tch</h4>
            <p className="text-xs text-secondary">Master Coach • EUNE</p>
          </div>
        </div>
      </section>

      {/* Latest Posts Carousel */}
      <LatestPostsCarousel />

      {/* FAQ Section */}
      <section id='faq' className="max-w-6xl w-full mx-auto py-14 px-4 sm:px-8 md:px-0">
        <h2 className="text-2xl font-bold text-center mb-2 text-[var(--blue)]">FAQ</h2>
        <p className="text-center text-sm text-secondary max-w-2xl mx-auto mb-8">
          Have questions? We’ve got answers! Check out our frequently asked questions below. If you need more help, feel free to reach out via live chat.
        </p>

        <Container
          maxWidth={false}      // ← allow 100% width
          disableGutters        // ← remove default side padding
          sx={{ width: '100%' }}// ← ensure it fills the section
        >
          <Box sx={{ width: '100%' }}>
            {faqItems.map(({ question, answer }, idx) => (
              <DarkAccordion
                key={idx}
                TransitionProps={{ unmountOnExit: true }}
                sx={{ width: '100%' }}  // ← each accordion fills width
              >
                <AccordionSummary
                  expandIcon={
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      size="lg"
                      style={{ color: 'var(--blue)' }}
                    />
                  }
                  aria-controls={`faq-content-${idx}`}
                  id={`faq-header-${idx}`}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" sx={{ color: 'var(--secondary-text)' }}>
                    {answer}
                  </Typography>
                </AccordionDetails>
              </DarkAccordion>
            ))}
          </Box>
        </Container>
      </section>

    </div>
  );
};

// Placeholder component definition
const ImagePlaceholder = ({ alt, width = 50, height = 50, className = '' }) => (
  <div
    role="img"
    aria-label={alt}
    className={className}
    style={{ width: `${width}px`, height: `${height}px`, backgroundColor: '#3a3a3a' }}
  ></div>
);


export default Home;


/* 
CSS Variables (to include in a global CSS or Tailwind config for theme):
:root {
  --bg-page: #0D0D0D;
  --bg-surface: #1E1E1E;
  --bg-surface-variant: #262626;
  --border: #2A2A2A;
  --focus-ring: rgba(0,186,255,0.5);
  --blue: #00BAFF;
  --secondary-text: #b3b3b3;
  --main: #00BAFF; /* adjust to your primary accent color

*/

